Auth = require 'db/auth'
Board = require 'models/board'
Dates = require 'lib/dates'
LimitMixin = require 'lib/limit-mixin'
DisplayEntityMixin = require 'models/internal/display-entity-mixin'
ReactionList = require 'models/collections/reaction-list'
TrelloModel = require 'models/internal/trello-model'
_ = require 'underscore'
mixin = require 'lib/mixin'

module.exports = class Action extends TrelloModel
  mixin DisplayEntityMixin, LimitMixin, @
  typeName: 'Action'
  urlRoot: '/1/actions'

  NAME_TRUNCATE_LENGTH = 64

  initialize: ->
    @reactionList = new ReactionList([]).syncCache @modelCache, [], (reaction) =>
      reaction.get('idModel') == @id

  getModel: -> @collection.options.model

  triggerCacheEvents: (modelCache, event) ->
    for idModel in @idModels()
      modelCache.trigger "#{ event }:#{ @typeName }:#{ idModel }"
    return

  isCommentLike: ->
    @get('type') in ['commentCard', 'copyCommentCard']

  isAddAttachment: ->
    @get('type') == 'addAttachmentToCard'

  isMember: (member) ->
    @get('idMemberCreator') == member.id

  getDate: ->
    Dates.parse(@get('date'))

  getBoard: ->
    @modelCache.get('Board', @get('data')?.board?.id)

  getCard: ->
    @modelCache.get('Card', @get('data')?.card?.id)

  getChecklist: ->
    @modelCache.get('Checklist', @get('data')?.checklist?.id)

  editable: ->
    # We can edit an action if it's a comment and it belongs to us
    idMemberCreator = @get('idMemberCreator')

    @get('type') in ['commentCard'] && Auth.isMe(idMemberCreator)

  deletable: ->
    idMemberCreator = @get('idMemberCreator')

    # We can delete an action if ...

    # - It's a comment
    @get('type') in ['commentCard'] &&
    (
      # - It belongs to us
      Auth.isMe(idMemberCreator) ||
      (
        # - It's associated with a board
        (board = @getBoard())? &&
        # - We have a higher permission level than the person who created it
        (board.compareMemberType(Auth.me(), @modelCache.get('Member', idMemberCreator), mode: 'commentDelete') > 0) &&
        # - We aren't trying to delete a premium organization admin's comment
        !(!board.isPremOrgAdmin(Auth.me()) && board.isPremOrgAdmin(idMemberCreator))
      )
    )

  isPlaceholder: ->
    !@get('date')?

  includesModel: (model) ->
    modelType = model.typeName.toLowerCase()
    idModel = model.id

    # Models that have been created locally but haven't been returned from
    # the server won't have an id yet
    if !idModel
      return false

    if modelType == 'member' && @get('idMemberCreator') == idModel
      return true

    data = @get('data')

    # Although this isn't expressed in the API, the idModels array for these
    # actions in the DB contains both the source and destination card, which
    # means that they're returned via the API response, which means that if
    # you *don't* have this check the action paging count gets all screwy.
    if @get('type') == 'convertToCardFromCheckItem' &&
        data.cardSource.id == idModel
      return true

    return data[modelType]?.id == idModel

  idModels: ->
    idModels = (value.id for key, value of (@get('data') ? {}) when value?.id?)
    idMemberCreator = @get('idMemberCreator')
    if idMemberCreator?
      idModels.push(idMemberCreator)
    idModels

  takingTooLong: ->
    @isTakingTooLong = true
    @trigger('takingTooLong')

  # FEATURE: tacoHearts - reactions launch. We are assuming here that if you can comment
  # you should also be able to react to something
  canReact: ->
    me = Auth.me()
    return @getBoard().canComment(me)

  isOverUniqueReactionsCapacity: ->
    @isOverLimit('reactions', 'uniquePerAction')

  isOverTotalReactionsCapacity: ->
    @isOverLimit('reactions', 'perAction')



// WEBPACK FOOTER //
// ./app/scripts/models/action.coffee